var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", [
    _vm.item && _vm.item.type === "wells"
      ? _c(
          "div",
          [
            _c("adapt-settings", {
              attrs: { problem: _vm.item },
              model: {
                value: _vm.task,
                callback: function ($$v) {
                  _vm.task = $$v
                },
                expression: "task",
              },
            }),
            _c(
              "v-btn",
              {
                staticClass: "mt-4",
                attrs: { large: "", color: "primary", disabled: !_vm.isValid },
                on: { click: _vm.saveTaskAndGotoNextStep },
              },
              [_vm._v("Далее")]
            ),
          ],
          1
        )
      : _c(
          "div",
          [
            _c("adapt-settings", {
              attrs: { problem: _vm.item },
              model: {
                value: _vm.task,
                callback: function ($$v) {
                  _vm.task = $$v
                },
                expression: "task",
              },
            }),
            _c(
              "div",
              { staticClass: "d-flex align-center" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "mt-4",
                    attrs: {
                      large: "",
                      color: "primary",
                      disabled: !_vm.isValid,
                    },
                    on: { click: _vm.saveTaskAndGotoNextStep },
                  },
                  [_vm._v("Далее")]
                ),
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    staticClass: "mt-4",
                    attrs: {
                      text: "",
                      color: "primary",
                      disabled: !_vm.isValid,
                    },
                    on: { click: _vm.downloadJson },
                  },
                  [_vm._v("Скачать JSON")]
                ),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }